// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3dywS","buttons":"Footer_buttons__H1_uT"};